import firebase from "firebase";
const firebaseConfig = {
  apiKey: "AIzaSyBVjR3So6uAtYzYMpvoRcYAvH6i2lSWwc8",
  authDomain: "hits-connect.firebaseapp.com",
  projectId: "hits-connect",
  storageBucket: "hits-connect.appspot.com",
  messagingSenderId: "811260839765",
  appId: "1:811260839765:web:f0ef8df64da0b04b2691dc",
  measurementId: "G-SH2SR8MVFF",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
